module.exports = "/images/historical_grey.png?bee269d81aefc3e5c8c089306845ed5b";